/**
 * @param email {string}
 * @return {boolean}
 */
module.exports = function shouldBlockEmailDomainSilently(email) {
    let silentBlockedEmailDomains = ""
    if ("silent_blocked_email_domains" in window.ITBL) {
        silentBlockedEmailDomains = atob(window.ITBL.silent_blocked_email_domains || "", true);
    }
    silentBlockedEmailDomains = silentBlockedEmailDomains.split(",");

    for (let i = 0; i < silentBlockedEmailDomains.length; i++) {
        const domain = silentBlockedEmailDomains[i];
        if (domain && email.endsWith(domain)) {
            return true;
        }
    }

    return false;
}